import { Navigate, useLocation } from 'react-router';
import { INDEX_PATH } from 'routes/constants';
import { ReactNode } from 'react';

import { isUnsubscribeQuery } from 'modules/unsubscribe/utils/isUnsubscribeQuery';

interface IUnsubscribeGuardProps {
  children?: ReactNode;
}

export const UnsubscribeGuard = ({ children }: IUnsubscribeGuardProps) => {
  const location = useLocation();

  const isUnsubscribe = isUnsubscribeQuery(location.search || '');

  if (isUnsubscribe) {
    return <>{children}</>;
  }

  return <Navigate to={INDEX_PATH} replace />;
};
